import React, { useState } from 'react'
import { Checkbox, FormDashboardInput as Input, FormDashboardInputControlled, OccupationAdder, RequiredLabel } from '../../../components'
import Select from 'react-select'
import { useSelector } from 'react-redux'
import { useInternationalization } from '../../../features/i18n'
import { X } from 'react-feather'

const selectPlaceholder = {
  en: 'Select...',
  id: 'Pilih...'
}

const phonePlaceholder = {
  en: 'Enter Phone Number',
  id: 'Masukkan Nomor Telepon'
}

const Label = ({children}) => {
  return <label className="inline-block text-sm text-gray-text mb-2">{children}</label>
}

const GuestRow = ({isFirst, number, onChange, onDelete = () => {}}) => {
  const [isSelf, setIsSelf] = useState(false)
  const [selectedOccupation, setSelectedOccupation] = useState([])
  const { genderOptionsByLanguage, disabilityOptions } = useSelector(state => state.system)
  const {
    name: myName,
    occupation: myOccupation,
    email: myEmail,
    phone: myPhone,
    gender: myGender,
    disability: myDisability
  } = useSelector(state => state.account.profile)
  const { translate, language } = useInternationalization()
  const genderOptions = genderOptionsByLanguage[language.name]

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      borderColor: '#ddd',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      paddingLeft: '1rem'
    }),
  }

  const handleOccupation = (occupations) => {
    const newOccupations = []

    if(occupations[0]){
      newOccupations.push(occupations[0])
      onChange({
        target: {
          name: 'occupation',
          value: occupations[0]
        }
      })
    } else {
      onChange({
        target: {
          name: 'occupation',
          value: {}
        }
      })
    }

    setSelectedOccupation(newOccupations)
  }

  const handleGender = (e) => {
    onChange({
      target: {
        name: 'gender',
        value: e
      }
    })
  }

  const handleDisability = (e) => {
    onChange({
      target: {
        name: 'disability',
        value: e
      }
    })
  }

  const handleCheckbox = (e) => {
    if (e.target) {
      setIsSelf(e.target.checked)
      onChange({
        target: {
          name: 'isSelf',
          value: e.target.checked
        }
      })

      setTimeout(() => {
        onChange({
          target: {
            name: 'name',
            value: myName
          }
        })
      }, 100)
    }
  }

  return (
    <div className="flex flex-wrap lg:-mx-4">
      <div className="w-full lg:px-4 lg:w-1/4 mb-4 lg:mb-0">
        <div className="w-full lg:pt-8">
          <p className="text-lg mb-5 font-bold">
            {translate('GUEST', 'singular')} #{number}
          </p>
          {
            isFirst ?
            <div>
              <Checkbox
                label={translate('EVENT', 'i_am_guest')}
                onChange={e => {e.persist(); handleCheckbox(e)}}
              />
            </div>
            : <X className="cursor-pointer text-gray-500" onClick={onDelete}/>
          }
        </div>
      </div>
      <div className="w-full lg:px-4 lg:w-3/4">
        <div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-8">
            <div className="w-full lg:w-1/2 px-4 mb-4 lg:mb-0">
              <Label>{translate('AUTH', 'full_name')} {!isSelf && <RequiredLabel />}</Label>
              {
                isSelf ? (
                  <FormDashboardInputControlled
                    placeholder={translate('AUTH', 'full_name')}
                    className="w-full"
                    name="name"
                    disabled={isSelf}
                    value={myName}
                  />
                ) : (
                  <Input
                    required
                    placeholder={translate('AUTH', 'full_name')}
                    className="w-full"
                    name="name"
                    onChange={e => {e.persist(); onChange(e)}}
                  />
                )
              }
            </div>
            <div className="w-full lg:w-1/2 px-4">
              <Label>{translate('GENERAL', 'occupation')}</Label>
              {
                isSelf ? (
                  <>
                    <OccupationAdder
                      noPreview
                      data={[myOccupation]}
                      isDisabled={isSelf}
                    />
                  </>
                ) : (
                  <OccupationAdder
                    noPreview
                    data={selectedOccupation}
                    onChange={handleOccupation}
                  />
                )
              }
            </div>
          </div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-8">
            <div className="w-full lg:w-1/2 px-4 ml-auto mb-4 lg:mb-0">
              <Label>{translate('AUTH', 'email')} {!isSelf && <RequiredLabel />}</Label>
              {
                isSelf ? (
                  <FormDashboardInputControlled
                    className="w-full"
                    disabled={isSelf}
                    value={myEmail}
                  />
                ) : (
                  <Input
                    required
                    placeholder={`contoh@email.com`}
                    className="w-full"
                    type="email"
                    onChange={e => {e.persist(); onChange(e)}}
                    name="email"
                  />
                )
              }
            </div>
            <div className="w-full lg:w-1/2 px-4">
              <Label>{translate('GENERAL', 'phone')} {!isSelf && <RequiredLabel />}</Label>
              {
                isSelf ? (
                  <FormDashboardInputControlled
                    className="w-full"
                    disabled={isSelf}
                    value={myPhone}
                  />
                ) : (
                  <Input
                    required
                    placeholder={phonePlaceholder[language.name]}
                    className="w-full"
                    onChange={e => {e.persist(); onChange(e)}}
                    name="phone"
                  />
                )
              }
            </div>
          </div>
          <div className="flex flex-wrap -mx-4 mb-4 lg:mb-0">
            <div className="w-full lg:w-1/2 px-4 ml-auto mb-4 lg:mb-0">
              {/* <div className="lg:pt-8">
                <Checkbox
                  label="Have a disability"
                />
              </div> */}

              <Label>{translate('GENERAL', 'disability_status')}</Label>
              {
                isSelf ? (
                  <Select
                    style={customStyles}
                    className="text-sm"
                    isDisabled={isSelf}
                    value={myDisability}
                  />
                ) : (
                  <Select
                    style={customStyles}
                    className="text-sm"
                    options={disabilityOptions}
                    onChange={handleDisability}
                    placeholder={selectPlaceholder[language.name]}
                  />
                )
              }
            </div>
            <div className="w-full lg:w-1/2 px-4">
              <Label>{translate('GENERAL', 'gender')}</Label>
              {
                isSelf ? (
                  <Select
                    style={customStyles}
                    className="text-sm"
                    options={genderOptions}
                    isDisabled={isSelf}
                    value={myGender}
                  />
                ) : (
                  <Select
                    style={customStyles}
                    className="text-sm"
                    options={genderOptions}
                    onChange={handleGender}
                    placeholder={selectPlaceholder[language.name]}
                  />
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GuestRow
